.body {
  margin-bottom: calc(var(--spacing) * 2);
}

.wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing);
}
